import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async shared(context, data) {
      try {
        const token = await axios.post('/shared', data, { withCredentials: true });
        return token.data;
      } catch (error) {
        throw error;
      }
    },
    async retriveToken(context, data) {
      try {
        const token = await axios.patch('/shared', data, { withCredentials: true });
        return token.data;
      } catch (error) {
        throw error;
      }
    },
    async retriveDataFromToken(context, data) {
      try {
        const config = { withCredentials: true };
        if (data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const response = await axios.get(`/shared/${data.token}`, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async disableToken(context, token) {
      try {
        await axios.delete(`/shared/${token}`, { withCredentials: true });
      } catch (error) {
        throw error;
      }
    },
  },
};
